import { ENCLOSED_SHADED_SELECTED_BACKGROUND_COLOR, ENCLOSED_SELECTED_BACKGROUND_COLOR } from '../TabConstants';

// Infer item type from array

export const USES = ['default', 'enclosed', 'enclosed-shaded', 'flush', 'header', 'toolbar'];
export const isContained = use => use === 'enclosed' || use === 'enclosed-shaded' || use === 'flush' || use === 'toolbar';
export const getSelectedTabBackgroundColor = use => use === 'enclosed-shaded' ? ENCLOSED_SHADED_SELECTED_BACKGROUND_COLOR : ENCLOSED_SELECTED_BACKGROUND_COLOR;